module.exports = __webpack_public_path__ + "img/flags.9182ae3b.png";